import script from "./ResultOutput.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultOutput.vue?vue&type=script&setup=true&lang=js"

import "./ResultOutput.vue?vue&type=style&index=0&id=1516a8aa&lang=scss"

const __exports__ = script;

export default __exports__